import axios from 'axios'

// iOS Safari対応のAxios設定
export const client = axios.create({
  timeout: 10000, // 10秒タイムアウト
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})
